import React, { useState, useEffect } from "react";
import { Loader2, Search } from "lucide-react";
import { loadFormSecure } from "../../secure/secureForm"; 
import { decryptFromStorage } from "../../secure/secureStorage"; 


export default function QueryForm({ onSubmit, isLoading, workspace }) {
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(100);

  useEffect(() => {
    if (!workspace?.id) return;
    const passphrase = sessionStorage.getItem("yassu_pf") || "";
    loadFormSecure(workspace.id, passphrase).then((state) => {
      setStartIndex(state.startIndex ?? 0);
      setEndIndex(state.endIndex ?? 100);
    });
  }, [workspace?.id]);


const handleSearch = async (targetFolder) => {
    const passphrase = sessionStorage.getItem("yassu_pf") || "";
    
    try {
        const realPassword = await decryptFromStorage(workspace.password, passphrase);

        const body = {
            username: workspace.email,
            appPassword: realPassword,
            folder: targetFolder,
            sinceDays: 0,
            startIndex: Number(startIndex) || 0,
            endIndex: Number(endIndex) || 100,
            paramHeaderName: "",
            paramHeaderValue: "",
        };

        if (typeof onSubmit === "function") {
            await onSubmit(body, { workspaceId: workspace.id });
        }
    } catch (err) {
        alert("Incorrect Passphrase or corrupted data.");
        console.error(err);
    }
};

const credsMissing = !workspace?.email || !workspace?.password;

  return (
    <div className="card shadow-sm mb-4">
      <div className="card-body">
        <div className="p-3 border rounded shadow-sm">
          <div className="row g-2 justify-content-center">
            {/* Start/End */}
            <div className="col-md-4">
              <div className="input-group input-group-sm">
                <span className="input-group-text">Start Index</span>
                <input
                  type="number"
                  className="form-control"
                  min="0"
                  value={startIndex}
                  onChange={(e) => setStartIndex(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="input-group input-group-sm">
                <span className="input-group-text">End Index</span>
                <input
                  type="number"
                  className="form-control"
                  min="1"
                  max="2000"
                  value={endIndex}
                  onChange={(e) => setEndIndex(e.target.value)}
                  required
                />
              </div>
            </div>
          </div>
 
          <div className="row g-2 mt-3">
            <div className="col-md-6">
              <button
                type="button"
                className="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                disabled={isLoading || credsMissing}
                onClick={() => handleSearch("INBOX")}
              >
                {isLoading ? <Loader2 size={20} className="spin-animation me-2" /> : <Search size={18} className="me-2" />}
                Get Inbox
              </button>
            </div>
            <div className="col-md-6">
              <button
                type="button"
                className="btn btn-danger w-100 d-flex align-items-center justify-content-center"
                disabled={isLoading || credsMissing}
                onClick={() => handleSearch("SPAM")}
              >
                {isLoading ? <Loader2 size={20} className="spin-animation me-2" /> : <Search size={18} className="me-2" />}
                Get Spam
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
